import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AiFillCopy } from 'react-icons/ai';
import Snackbar from '@material-ui/core/Snackbar';

import {
  CalcSolution,
  SolutionWrapper,
  Parag,
  CopyButton,
} from '../../styled/stylezz';

const Td = styled.td`
  &&&& {
    border: 1px solid #e0e0e0;
    color: blue;
    width: 1.3em;
    height: 1.3em;
    vertical-align: middle;
    text-align: center;
    padding: 0px;
  }
`;

const Table = styled.table`
  &&&& {
    margin: 20px auto;
    box-shadow: 0px 0px 15px 4px white;
    border-collapse: collapse;
    background: white;
  }
`;

const SolutionCalc = ({ inputA, inputB, answer }) => {
  const [stack, setStack] = useState([]);
  const [newA, setNewA] = useState([]);
  const [newB, setNewB] = useState([]);
  const [openSnackBar, setOpenSnackBar] = useState(false);

  useEffect(() => {
    if (answer === 0) {
      return;
    } else {
      try {
        const multiplyAB = (a, b) => {
          const aa = a.toString().split('').reverse();
          const bb = b.toString().split('').reverse();
          const stack = [];
          for (let i = 0; i < bb.length; i++) {
            const stack2 = [];
            let sliceNumber = 0;
            stack.push(stack2);
            for (let j = 0; j < aa.length; j++) {
              let m = bb[i] * aa[j];
              m += +sliceNumber;

              if (m < 10) {
                stack2.unshift(+m);
                sliceNumber = 0;
              } else {
                if (j < aa.length - 1) {
                  stack2.unshift(+m.toString().slice(-1));
                  sliceNumber = m.toString()[0];
                } else {
                  stack2.unshift(m);
                }
              }
            }
          }
          const restack = stack.map((i) => i.join('').split(''));
          setStack(restack);
        };
        multiplyAB(Math.abs(+inputA), Math.abs(+inputB));

        if ([...inputA].length < [...inputB].length) {
          const raznica = new Array(
            [...inputB].length - [...inputA].length,
          ).fill(null);
          const newA = [...raznica, ...inputA];
          setNewA(newA);
          setNewB([...inputB]);
        } else if ([...inputA].length > [...inputB].length) {
          const raznica = new Array(
            [...inputA].length - [...inputB].length,
          ).fill(null);
          const newB = [...raznica, ...inputB];
          setNewB(newB);
          setNewA([...inputA]);
        } else {
          setNewB([...inputB]);
          setNewA([...inputA]);
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  }, [inputA, inputB, answer]);

  const handleCopy = () => {
    navigator.clipboard.writeText(answer);
    setOpenSnackBar(true);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };
  return (
    <SolutionWrapper>
      <>
        {answer === 0 || isNaN(answer) ? (
          <>
            <Parag>Ответ:</Parag>
            <CalcSolution style={{ textAlign: 'center' }}>
              {inputA || 0} &times; {inputB || 0} = 0
            </CalcSolution>
          </>
        ) : (
          <>
            <Parag>Ответ:</Parag>
            <CalcSolution style={{ textAlign: 'center' }}>
              {+inputA} &times; {+inputB} = {answer}
              <Table>
                <tbody>
                  <tr>
                    {new Array(answer.toString().length - newB.length)
                      .fill(null)
                      ?.map((i) => (
                        <Td key={Math.random()}>{i}</Td>
                      ))}
                    <Td
                      rowSpan={2}
                      style={{ borderBottom: '2px solid black', color: 'red' }}
                    >
                      X
                    </Td>
                    {newA.map((i, idx) => (
                      <Td key={idx * Math.random()}>{i}</Td>
                    ))}
                  </tr>

                  <tr>
                    {new Array(answer.toString().length - newB.length)
                      .fill(null)
                      ?.map((i) => (
                        <Td key={Math.random()}>{i}</Td>
                      ))}
                    {newB.map((i, idx) => (
                      <Td
                        style={{ borderBottom: '2px solid black' }}
                        key={idx * Math.random()}
                      >
                        {i}
                      </Td>
                    ))}
                  </tr>
                  {inputA.length > 1 && inputB.length > 1
                    ? stack.map((i, idx) => {
                        return (
                          <tr key={idx * Math.random()} align="right">
                            {new Array(
                              answer.toString().length + 1 - i.length - idx,
                            )

                              .fill(null)
                              ?.map((i) => (
                                <Td key={Math.random()}>{i}</Td>
                              ))}
                            {i.map((itemTd, idxTd) => (
                              <Td key={idxTd * Math.random()}>{itemTd}</Td>
                            ))}
                            {idx > 0 &&
                              new Array(idx)
                                .fill(null)
                                ?.map((i) => <Td key={Math.random()}>{i}</Td>)}
                          </tr>
                        );
                      })
                    : null}
                  <tr>
                    <Td></Td>
                    {[...answer.toString()].map((i) => (
                      <Td
                        key={Math.random()}
                        style={{
                          borderTop: '2px solid black',
                          color: 'red',
                        }}
                      >
                        {i}
                      </Td>
                    ))}
                  </tr>
                </tbody>
              </Table>
              <CopyButton onClick={handleCopy}>
                <AiFillCopy
                  size={20}
                  style={{ color: '#5095df', marginRight: '10px' }}
                />
                Копировать ответ
              </CopyButton>
              <Snackbar
                achororigin={{
                  vertical: 'center',
                  horizontal: 'center',
                }}
                open={openSnackBar}
                autoHideDuration={2000}
                message="Ответ скопирован"
                onClose={handleClose}
                ContentProps={{
                  style: {
                    background: '#5095df',
                  },
                }}
              />
            </CalcSolution>
          </>
        )}
      </>
    </SolutionWrapper>
  );
};

export default SolutionCalc;
